import InstructionalVerbiage from "./instructional-verbiage";

export default InstructionalVerbiage;
